/*    
<summary>
   This functional common component provides us custom input box & has error handler that shows validation error. 
   Developer:Aashish Singh, Created Date:08-Mar-2023
</summary>
<returns>Returns JSX</returns>
*/
import React, { useState } from "react";
import { injectIntl } from "react-intl";
import FormikFormErrorHandler from "./FormikFormErrorHandler";
import { useField } from "formik";

interface IProps {
  children: React.ReactNode;
  className: string;
  errclassname: string | undefined;
  testid?: string;
  intl: any; //IntlConfig;
  name: string;
  onBlur: () => void;
  onChange: () => void;
  onInput: () => void;
  placeholder: string;
  type: string;
  value: string;
  disabled: boolean;
  readOnly: boolean;
  spaceAllowed: boolean;
  validcharacter?: Array<string>;
  invalidcharacter?: Array<string>;
  refData?: any;
  max?:number;
}

const FormikFormOTPInput = (props: IProps) => {
  const [field, meta, helpers] = useField(props);
  const errorClass = `${meta.error && meta.touched ? "error" : ""}`;
  const { validcharacter, invalidcharacter } = props;
  const [value, setValue] = useState<any>("");
  const _placeholder = props.placeholder
    ? props.intl.formatMessage({ id: props.placeholder })
    : props.placeholder;

  let subStrArr = [
    "?",
    ">",
    "<",
    "'",
    '"',
    ":",
    ";",
    ",",
    "+",
    "-",
    "(",
    ")",
    "*",
    "&",
    "^",
    "%",
    "$",
    "#",
    "{",
    "[",
    "]",
    "}",
    "|",
    "/",
    "\\",
    "=",
    "_",
    "!",
    "~",
    "`",
    ".",
    "@"
  ];
  if (invalidcharacter) invalidcharacter.forEach((el) => subStrArr.push(el));
  if (validcharacter)
    subStrArr = subStrArr.filter((el) => !validcharacter.includes(el));
  
  const handleKeyPress = (event:React.KeyboardEvent<HTMLInputElement>) => {
    const keyCode = event.keyCode || event.which;
    const keyValue = String.fromCharCode(keyCode);

    // Allow only numeric input (0-9)
    if (!/^\d+(\.\d+)?$/.test(keyValue)) {
      event.preventDefault();
    }
  };
  return (
    <>
      <input
        {...field}
        {...props}
        id={props.testid}
        maxLength={props.max}
        placeholder={_placeholder}
        className={props.className + " " + errorClass}
        disabled={props.disabled}
        type={props.type}
        readOnly={props.readOnly}
        ref={props.refData}
        onKeyDown={
          props.type === "number"
            ? (evt) =>
                ["e", "E", "+", "-"].includes(evt.key) && evt.preventDefault()
            : undefined
        }
        onInput={props.onInput}
        onKeyPress={
          props.type === "number"
            ? (evt) =>{
              handleKeyPress(evt);
            }
            : undefined
        }
        onChange={(event) => {
          if(props.type == "number"){
            const inputValue =  event.target.value?.trim()?.length <= 1 ? event.target.value : event.target.value[0];
    
            // Check if the input matches the allowed pattern
            if (/^\d*\.?\d*$/.test(inputValue)) {

              helpers.setValue(inputValue);
            }
          }
          else{
            if (
              !props.spaceAllowed &&
              (event.target.value === "" ||
                !subStrArr.some((subStr: any) =>
                  event.target.value.includes(subStr)
                ))
            ) {
              helpers.setValue(event.target.value);
            } else if (
              (props.spaceAllowed === undefined || props.spaceAllowed) &&
              (event.target.value === "" ||
                !subStrArr.some((subStr: any) =>
                  event.target.value.includes(subStr)
                ))
            ) {
              helpers.setValue(event.target.value);
            }
          }
        }}
      />
      <FormikFormErrorHandler intl={props.intl} meta={meta} />
    </>
  );
};

export default injectIntl(FormikFormOTPInput);
